import React from 'react';

import { DASH } from 'Components/budget_change_requests/changeRequestFormat';
import moment from 'moment';

import { formatFigure, formatMoneyWithLocale } from 'Helpers/formatService';

/** Money as the Direct Commitment screen shows it; a zero in a table cell is the dash. */
export const figure = (value) => formatFigure(value, formatMoneyWithLocale, { precision: 3 });

export const amount = (value) => formatMoneyWithLocale(Number(value ?? 0));

/**
 * A solid blue footer cell. The table skin paints every body cell white with a grey
 * bottom rule, so both are forced to blue per cell; the side shadows cover the hairline
 * seam fractional column widths leave between two cells of the same colour.
 */
export const FOOTER_CELL = '!tw-bg-blue !tw-text-white !tw-border-b-blue tw-shadow-[1px_0_0_theme(colors.blue.DEFAULT),-1px_0_0_theme(colors.blue.DEFAULT)]';

/** A calendar date the server sends as `Y-m-d`. It names a day, so no timezone moves it. */
export const calendarDate = (value) => (value ? moment(value, 'YYYY-MM-DD').format('D MMM YYYY') : DASH);

/** Points from the before figure to the after one, in either reading direction. */
export const ChangeArrow = () => (
    <span aria-hidden="true" className="tw-inline-block rtl:tw-rotate-180">
        &rarr;
    </span>
);
